var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "inner w100" }, [
    _c(
      "div",
      {
        staticClass: "wallet-title",
        class: { "active-wallet": _vm.opened },
        on: { click: _vm.open }
      },
      [
        _c("div", [
          _vm.groupByinnerClient
            ? _c("p", { staticClass: "grouped-title" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.i18n.lbl_client_group()) +
                    " - " +
                    _vm._s(_vm.innerWallet[0].ClientName) +
                    "\n          "
                )
              ])
            : _c("p", { staticClass: "grouped-title" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.i18n.lbl_direction_group()) +
                    " - " +
                    _vm._s(_vm.innerWallet[0].Description) +
                    "\n          "
                )
              ])
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "wallet-arrow-wrap" },
          [
            _c("p", [_c("span", [_vm._v(_vm._s(_vm.sumBalance))])]),
            _vm._v(" "),
            _c(
              "md-icon",
              { staticClass: "arrow-down-icon-aml md-icon-size-065x" },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      height: "24",
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 24 24"
                    }
                  },
                  [
                    _c("path", {
                      attrs: {
                        d: "M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"
                      }
                    })
                  ]
                )
              ]
            )
          ],
          1
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.opened,
            expression: "opened"
          }
        ]
      },
      _vm._l(_vm.innerWallet, function(group, index) {
        return _c("div", { key: "inner-groupt-" + index }, [
          _c(
            "div",
            {
              staticClass:
                "text_medium protfolio-subwallet subwallets-flex accordioned",
              on: {
                click: function($event) {
                  return _vm.setInnerActive(group)
                }
              }
            },
            [
              _c("span", { staticClass: "wallet-field small-float" }, [
                _vm._v(
                  _vm._s(
                    _vm.groupByinnerClient
                      ? group.ClientName
                      : group.Description
                  )
                )
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "wallet-field" }, [
                _vm._v(
                  _vm._s(
                    _vm.groupByinnerClient
                      ? group.Description
                      : group.ClientName
                  )
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "wallet-field" }, [
                _c("span", { staticClass: "subwallet-balance" }, [
                  _vm._v(_vm._s(group.Balance))
                ]),
                _vm._v(" "),
                _c("span", [_vm._v(_vm._s(group.Asset))])
              ])
            ]
          )
        ])
      }),
      0
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5732869a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5732869a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/dashboard/index/InnerAccordion.vue
// module id = CN1/
// module chunks = 1